document.addEventListener("DOMContentLoaded", () => {
    const images = document.querySelectorAll('img[loading="lazy"]');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;

                    const onLoad = () => {
                        img.classList.add('lazyloaded');
                        img.removeEventListener('load', onLoad);
                    };

                    if (img.complete) {
                        onLoad();
                    } else {
                        img.addEventListener('load', onLoad);
                    }

                    obs.unobserve(img);
                }
            });
        }, {
            rootMargin: '100px',
            threshold: 0.01
        });

        images.forEach(img => observer.observe(img));
    }
});
